<template>
	<div>
		<div class="jiben" v-loading="loading">
			<div class="jiben_top">
				<div class="jiben_tilel">基本信息</div>
				<div class="jiben_btn_box">
					<el-button 
						class="btn_item"
						v-if="allAuth.customer && allAuth.customer.update"
						@click="handleAction({'type':'update'})">修改</el-button>
					<el-button 
						class="btn_item"
						v-if="allAuth.customer && allAuth.customer.delete"
						@click="handleAction({'type':'delete'})">删除</el-button>
					<!-- <el-button 
						class="btn_item"
						@click="back()">返回</el-button> -->
				</div>
			</div>
			<div style="margin-top: 10px;">
				<table
					class="table table-hover">
					<tbody>
						<tr 
							v-for="(item,index) in list"
							:key="index">
							<td class="tdleft" width="15%">{{item[0].name}}</td>
							<template v-if="item.length > 1">
								<td width="35%">
									<span v-if="item[0].form_type == 'user' || item[0].form_type == 'user-multiple'">
										<template v-for="(i,k) in item[0].value">
											{{i.username}}{{k > 0 ? ',' :''}}
										</template>
									</span>
									<span v-else>
										{{item[0].value ? item[0].value : '---'}}
									</span>
								</td>
								<td class="tdleft" width="15%">{{item[1]? item[1].name :''}}</td>
								<td width="35%">
									<span v-if="item[1].form_type == 'user' || item[1].form_type == 'user-multiple'">
										<template v-for="(i,k) in item[1].value">
											{{i.username}}{{k > 0 ? ',' :''}}
										</template>
									</span>
									<span v-else>
										{{item[1].value ? item[1].value : '---'}}
									</span>
								</td>
							</template>
							<template v-else>
								<td colspan="3">
									<span v-if="item[0].form_type == 'file'">
										<span 
											v-if="item[0].value.length > 0"
											v-for="(v,k) in item[0].value"
											:key="k">
											<!-- <a :href="v.file_path" style="display: block;" target="_blank">{{v.name}}</a> -->
											<a
												v-if="v.file_type == 'image'"
												@click="previewImg(item[0].value, k)"
												href="javascript:void(0);"
												style="display: block;">{{v.name}}</a>
											<a
												v-else-if="v.file_type == 'viewfile'"
												:href="v.file_path"
												target="_blank"
												style="display: block;">{{v.name}}</a>
											<a
												v-else
												:href="'https://view.officeapps.live.com/op/view.aspx?src='+v.file_path"
												target="_blank"
												style="display: block;">{{v.name}}</a>
										</span>
										<span v-else>
											---
										</span>
									</span>
									<span v-else-if="item[0].form_type == 'user' || item[0].form_type == 'user-multiple'">
										<template v-for="(i,k) in item[0].value">
											{{i.username}}{{k > 0 ? ',' :''}}
										</template>
									</span>
									<span v-else>
										{{item[0].value}}
									</span>
								</td>
							</template>
						</tr>
					</tbody>
				</table>
			</div>
			<div style="margin-top: 35px;">
				<!-- 客户联系方式 -->
				<sections
					class="b-cells" 
					title="客户联系方式" 
					m-color="#46CDCF" 
					content-height="auto"
					:show-save="true"
					type="save_contacts"
					@save="handleAction">
					<flexbox
						:gutter="0" 
						wrap="wrap" 
						style="padding:10px 8px;margin-top:5px;">
						<el-table
							:data="contactsList"
							stripe
							border
							:header-cell-style="{'background-color':'#f6faff'}"
							style="width: 100%">
							<el-table-column prop="contacts_name" label="联系人姓名" width="200"></el-table-column>
							<el-table-column prop="telephone" label="电话/微信" width="200"></el-table-column>
							<el-table-column prop="create_time" label="创建时间"></el-table-column>
							<el-table-column
								align="center"
								label="操作"
								v-if="allAuth.customer.update_contacts || allAuth.customer.del_contacts">
									<template slot-scope="scope">
										<a
											v-if="allAuth.customer.update_contacts"
											href="javascript:void(0)" 
											@click="handleAction({'type':'update_contacts','data':scope.row})">
											修改
										</a>
										<a 
											v-if="allAuth.customer.del_contacts"
											href="javascript:void(0)" 
											@click="handleAction({'type':'del_contacts','data':scope.row})">
											删除
										</a>
									</template>
							</el-table-column>
						</el-table>
					</flexbox>
				</sections>
			</div>
			
			<div style="margin-top: 35px;">
				<sections
					class="b-cells" 
					title="跟进日志" 
					m-color="#46CDCF" 
					content-height="auto">
					<c-r-m-customer-log
						:crmType="crmType"
						:id="this.$route.params.id"/>
				</sections>
			</div>
		</div>
		<!-- dialog弹窗 -->
		<dialog-form
			:dialog-visible="dialogForm"
			:title="title"
			ref="crmform"  
			:crm-type="crmType"
			:fields-data = "fieldsData"
			:action="action"
			:form-data="formData"
			@close = "closeDialog"
			@save-dialog="saveDialog">
		</dialog-form>
		
		<!-- 员工 -->
		<relate-empoyee 
			:visible.sync="transferDialogShow" 
			:type="type"
			:radio="radio"
			title="请选择员工"
			@save="employeesSave" />
	</div>
</template>

<script>
	import { createLogger, mapGetters } from 'vuex'
	import { filedGetField } from '@/api/setting/setting'
	import Sections from '../../customer/Sections'
	import DialogForm from '@/components/FromData/dialogForm'
	// 员工组件
	import RelateEmpoyee from '@/views/setting/auth/components/relateEmpoyee'
	import {
		crmContactsSave,
		crmContactsUpdate,
		crmContactsDel ,
		crmCustomerRead,
		crmCustomerUpdate,
		crmCustomerDelete
	} from '@/api/customer/customer'
	// 日志
	import CRMCustomerLog from '@/components/table/new/customer/CRMCustomerLog'
	export default {
		components: {
			Sections,
			DialogForm,
			RelateEmpoyee,
			CRMCustomerLog
		},
		computed: {
			...mapGetters(['allAuth'])
		},
		data() {
			return {
				loading:false,
				list:[],
				// 联系人信息
				contactsList:[],
				
				// dialog弹窗
				dialogForm:false,
				title:"",
				dialogType:"",
				fieldsData:[],
				action:{ type: '',actiontype:'',relevant:'' },
				formData:{},
				detailData:{},
				
				// 员工
				transferDialogShow:false,
				type:'',
				radio:true
			}
		},
		props: {
			crmType: {
				type: String,
				default: ''
			}
		},
		mounted() {
			this.getBaseInfo()
			this.getDetial()
		},
		computed: {
			...mapGetters(['allAuth']),
		},
		methods: {
			// 获取基础信息
			getBaseInfo() {
				this.loading = true
				filedGetField({
						types: 'crm_'+this.crmType,
						module: 'crm',
						controller: this.crmType,
						action: 'read',
						action_id: this.$route.params.id
					})
					.then(res => {
						let arr = this.setNewData(res.data.baseinfo)
						
						this.loading = false
						
						this.list = JSON.parse(JSON.stringify(arr))
						this.contactsList = JSON.parse(JSON.stringify(res.data.contacts))
					})
					.catch(() => {
						this.loading = false
					})
			},
			
			// 获取详情
			getDetial(){
				crmCustomerRead({
					id: this.$route.params.id
				})
				  .then(res => {
				    this.detailData = res.data
				  })
				  .catch(err => {
				    if (err && err.code == 102) {
				      this.hasRequestAuth = false
				    }
				    this.loading = false
				  })
			},
			
			// 组合数据
			setNewData(res){
				if(res == undefined || res.length <= 0) return []
				let listArr = res
				let one_arr = []
				let two_arr = []
				// 提取数组单元素
				for(var i=0;i<listArr.length;i++){
				    if(!listArr[i].isrows){
						one_arr.push(listArr[i])
					}else{
						two_arr.push([listArr[i]])
					}
				}
				let new_one_arr= [];
				for(var i=0;i<one_arr.length;i+=2){
				    new_one_arr.push(one_arr.slice(i,i+2));
				}
				let arr = new_one_arr.concat(two_arr)
				// console.log(arr);
				return arr
			},
			
			
			// 添加信息
			handleAction(item){
				let items = {}
				switch (item.type){
					case "save_contacts":
						this.title = "新增联系人信息"
						this.dialogForm = true
						this.action = { type: 'save',relevant:'contacts',actiontype:14 }
						break;
						
					case "update_contacts":
						this.title = "修改联系人信息"
						this.dialogForm = true
						this.action = { type: 'update',relevant:'contacts',actiontype:15 }
						items = JSON.parse(JSON.stringify(item.data))
						this.formData = items
						break;
					case "del_contacts":
						this.delInfo({"type":item.type,"data":item.data})
						break;
						
					case "update":
						this.title = "修改信息"
						this.dialogForm = true
						this.action = { type: 'update',relevant:"customer",actiontype:16 }
						// 预约时间格式转换
						let items = JSON.parse(JSON.stringify(this.detailData))
						let filter = this.$options.filters['filterTimestampToFormatTime']
						items['zixun_time'] = filter(items['zixun_time'])
						this.formData = items
						break;
						
					case "delete":
						this.delInfo({"type":item.type})
						break;
							
					default:
						break;
				}
			},
			
			delInfo(item){
				let request
				let id
				let team_user_id
				if(item.type == "del_contacts"){
					request = crmContactsDel
					id = item.data.id
				}else if(item.type == "delete"){
					request = crmCustomerDelete
					id = this.$route.params.id
				}
				this.$confirm('确定删除?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				})
				.then(() => {
					request({
						id:id,
						team_user_id: team_user_id
					})
					.then(res => {
						this.$message.success(res.data)
						if(item.type == "del_contacts"){
							this.getBaseInfo()
						}else{
							this.$router.push({ path: "/customer/allcustomer"})
						}
					})
					.catch(() => {})
				})
				.catch(() => {
					this.$message({
						type: 'info',
						message: '已取消操作'
					})
				})
			},
			
			// 弹窗操作
			closeDialog(){
				this.title = ""
				this.dialogForm = false
				this.formData = {}
			},
			
			// 保存操作
			saveDialog(item){
				let data = item.data
				data["customer_id"] = this.$route.params.id
				let request
				if(item.type == "save_contacts"){
					request = crmContactsSave
				}else if(item.type == "update_contacts"){
					request = crmContactsUpdate
				}else if(item.type == "update_customer"){
					request = crmCustomerUpdate
				}
				
				request(data)
					.then(res => {
						this.$message.success(res.data)
						this.closeDialog()
						this.getBaseInfo()
						this.getDetial()
					})
			},
			
			/**
			 * 员工
			 */
			employeesSave(val) {
				if(!val.type) return
				let request
				let owner_user_id
				if (val.type == 'save_team') {
					request = crmCustomerTeamSave
					owner_user_id = val.users[0].id
				}
				
				request({
						id: this.$route.params.id,
						owner_user_id: owner_user_id
					})
					.then(res => {
						this.$message.success(res.data)
						this.transferDialogShow = false
						this.getBaseInfo()
					})
					.catch(() => {})
				
			},
			
			
			// 返回
			back(){
				this.$router.back()
			},
			
			// 预览图片
			previewImg(list, index) {
				this.$bus.emit('preview-image-bus', {
					index: index,
					// data:[{"url":item.file_path,"name":item.name}]
					data: list.map(function(item, index, array) {
						item.url = item.file_path
						return item
					})
				})
			},
		},
	}
</script>

<style scoped>
	.jiben_btn_box {
		display: flex;
	}
	
	.btn_item {
		margin: 0 5px;
		color: #fff;
		background-color: #f36b6b;
		font-size: 12px;
		padding: 10px 10px;
	}
	
	.jiben_tilel {
		height: 100%;
		display: flex;
		align-items: center;
		font-size: 15px;
		font-weight: 600;
		margin-left: 10px;
	}
	
	.jiben_top {
		height: 50px;
		align-items: center;
		border-bottom: 1px solid #f2f2f2;
		display: flex;
		justify-content: space-between;
	}
	
	.jiben {
		padding: 10px;
		background-color: #fff;
		font-size: 14px;
	}
	.table{
		width: 100%;
		font-size: 12px !important;
	}
	/deep/ .el-table{
		font-size: 12px !important;
	}
	.table td {
		vertical-align: middle;
		padding: 15px 10px;
		line-height: 20px;
		border: 1px solid #EEEEEE;
		white-space: pre-wrap;
		word-break: break-all;
	}
	.table td.tdleft {
		text-align: center;
		background: #f6faff;
	}
	.table tr:hover {
		background: #f6faff;
	}
	/deep/ .f-container{
		margin-left: 0px !important;
	}
</style>